import * as $modal from './_modal'
import * as $blogpostpopup from './blog.blogpostpopup'

export interface IInitOptions {
    pageName: string
    pagePrefix: string
}

var options: IInitOptions

export function init($options: IInitOptions): void {
    options = $options

    $('.' + options.pagePrefix + '-download-modal').click(function () {
        const link: JQuery = $(this)
        const guid: string = link.attr('data-guid')

        $modal.show(
            '<p>Klicka på länken nedan för att ladda ner och spara din fil. Genom att göra det, ' +
                'godkänner du våra villkor för exporterad data, och kommer att debiteras/faktureras ' +
                'enligt gällande prislista.</p>' +
                '<p>Vill du inte fortsätta, behöver du inte göra någonting, och kommer då heller inte ' +
                'debiteras/faktureras någonting.</p>' +
                '<p><a href="/Export/GetFile?file=' +
                guid +
                '&approve=true" target="_blank" class="' +
                options.pagePrefix +
                '-modal-continue">Ladda ner fil</a></p> ' +
                '<p>Har du frågor kring detta - kontakta supporten på ' +
                '<a style="white-space:nowrap" href="tel:0707254618">070-725 46 18</a> eller maila oss på ' +
                '<a style="white-space:nowrap" href="mailto:camo@biscom.se">camo@biscom.se</a>.</p> ' +
                '<p><button class="bcfla-btn bcfla-btn-primary bcfla-btn-sm ' +
                options.pagePrefix +
                '-modal-close">Stäng</button></p>',
            false,
            false,
            false
        )

        $('#bcfla-modal-text .' + options.pagePrefix + '-modal-continue').click(function () {
            // after clicking and approving, reload the current list so the new ok status is shown
            setTimeout(() => {
                location.reload()
            }, 1000)
        })

        $('#bcfla-modal-text .' + options.pagePrefix + '-modal-close').click(function () {
            $modal.hide()
        })
    })

    $blogpostpopup.load(7)
}
